import { AppProps } from "next/app";
import localFont from "next/font/local";
import { useRouter } from "next/router";
import { useEffect } from "react";

import "@afa-shared/afa-components/dist/index.css";
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import "@public/print.css";

import "../styles/cookieTractor.css";
import "../styles/globals.css";

const ambit = localFont({
  src: [
    {
      path: "../fonts/Ambit-Regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "../fonts/Ambit-Regular.woff",
      weight: "400",
      style: "normal",
    },
    {
      path: "../fonts/Ambit-Bold.woff2",
      weight: "700",
      style: "normal",
    },
    {
      path: "../fonts/Ambit-Bold.woff",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-ambit",
  display: "swap",
  adjustFontFallback: false,
});

const App = ({ Component, pageProps }: AppProps): React.ReactNode => {
  const router = useRouter();

  // Disable prefetch on hover, see https://github.com/vercel/next.js/discussions/24437
  useEffect(() => {
    router.prefetch = async () => {};
  }, [router]);

  return (
    <ContentfulLivePreviewProvider
      locale="sv-SE"
      enableInspectorMode
      enableLiveUpdates={false}
      debugMode={false}
    >
      <div className={ambit.variable}>
        <Component {...pageProps} />
      </div>
    </ContentfulLivePreviewProvider>
  );
};

export default App;
